import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({
  name: 'isEmpty',
  standalone: true,
})
export class IsEmptyPipe implements PipeTransform {
  transform(value: unknown) {
    return isEmpty(value);
  }
}
